import React from 'react';
import { RouteObject } from 'react-router-dom';
import {
    BillingProvider,
    DocumentPreviewOverlay,
    DocumentPreviewProvider,
    DossierPrescriberProvider,
} from '@europrocurement/l2d-modules';
import {
    ordersBasePath,
    orderDetailPath,
    listeordersPath,
    ordersFacturationPath,
} from './constants';
import { OrderRoot, OrderDetail, ListeOrders } from './views';
import { FacturationTab } from '../Dossiers/components';
import OrderDuplicateWrapper from './views/detail/OrderDuplicateWrapper';

export const OrderRouter: RouteObject = {
    path: ordersBasePath,
    element: <OrderRoot />,
    children: [
        {
            path: listeordersPath,
            index: true,
            element: <ListeOrders />,
        },
        {
            path: orderDetailPath,
            element: <OrderDetail />,
        },
        {
            path: `${orderDetailPath}/duplication`,
            element: <OrderDuplicateWrapper />,
        },
        {
            path: ordersFacturationPath,
            element: (
                <BillingProvider origine="B2D">
                    <DocumentPreviewProvider>
                        <DossierPrescriberProvider>
                            <FacturationTab />
                            <DocumentPreviewOverlay />
                        </DossierPrescriberProvider>
                    </DocumentPreviewProvider>
                </BillingProvider>
            ),
        },
    ],
};
